import React, { useRef, useState } from "react";
import "./AdVariants.css";

function AdVariants() {
  const [folderId, setFolderId] = useState("");
  const [variantFiles, setVariantFiles] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("");
  const fileInputRef = useRef(null);

  const handleFileChange = (e) => {
    const files = Array.from(e.target.files || []);
    setVariantFiles(files);
    setMessage(files.length > 0 ? `${files.length} file(s) selected.` : "");
    setStatus(files.length > 0 ? "info" : "");

    files.forEach((file) => {
      console.log("Selected:", file.webkitRelativePath || file.name);
    });
  };

  const handleUpload = async () => {
    if (!folderId.trim() || variantFiles.length === 0) {
      setMessage("Please enter a folder ID and select variant images.");
      setStatus("error");
      return;
    }

    const formData = new FormData();
    formData.append("folderId", folderId.trim());

    variantFiles.forEach((file) => {
      formData.append("variants", file);
      formData.append("paths", file.webkitRelativePath || file.name);
      console.log("Sending file:", file.name, "at", file.webkitRelativePath || file.name);
    });

    try {
      setUploading(true);
      setMessage("Uploading variant files...");
      setStatus("info");

      const response = await fetch("https://api.malidag.com/upload-variants", {
        method: "POST",
        body: formData,
      });

      const result = await response.json();

      if (response.ok) {
        setMessage(`Upload successful: ${result.message}`);
        setStatus("success");
        setVariantFiles([]);
        setFolderId("");

        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      } else {
        setMessage(`Upload failed: ${result.message}`);
        setStatus("error");
      }
    } catch (error) {
      console.error("Error uploading variants:", error);
      setMessage("An error occurred during upload.");
      setStatus("error");
    } finally {
      setUploading(false);
    }
  };

  return (
    <div className="ad-variants">
      <div className="ad-variants__header">
        <h3 className="ad-variants__title">Upload Images-Variants Folder</h3>
        <p className="ad-variants__subtitle">
          Select a folder and upload all variant images, including subfolders.
        </p>
      </div>

      <div className="ad-variants__form">
        <div className="ad-variants__field">
          <label htmlFor="folderId" className="ad-variants__label">
            Folder ID
          </label>
          <input
            id="folderId"
            type="text"
            value={folderId}
            onChange={(e) => setFolderId(e.target.value)}
            placeholder="Enter folder ID"
            className="ad-variants__input"
          />
        </div>

        <div className="ad-variants__field">
          <label htmlFor="variantFolder" className="ad-variants__label">
            Select images-variants folder
          </label>
          <input
            id="variantFolder"
            ref={fileInputRef}
            type="file"
            webkitdirectory=""
            directory=""
            multiple
            onChange={handleFileChange}
            className="ad-variants__file-input"
          />
          {variantFiles.length > 0 && (
            <p className="ad-variants__file-count">
              {variantFiles.length} file(s) ready for upload
            </p>
          )}
        </div>

        <button
          className="ad-variants__button"
          onClick={handleUpload}
          disabled={uploading}
        >
          {uploading ? "Uploading..." : "Upload Folder"}
        </button>

        {message && (
          <div className={`ad-variants__message ad-variants__message--${status}`}>
            {message}
          </div>
        )}
      </div>
    </div>
  );
}

export default AdVariants;